// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__AhVtA","linkText":"Footer_linkText__obmfj","copyRight":"Footer_copyRight__4O2Om"};